
export class SortieProdPrintDTO {
  workflowInstanceId: number;
  printMode : string;
}
